import React from "react";
import * as Bananas from "bananas-commerce-admin";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

export interface CloseConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export const CloseConfirmationDialog: React.FC<
  CloseConfirmationDialogProps
> = ({ open, onClose, onConfirm, isDeleting = false }) => {
  const { t } = Bananas.useI18n();

  const title = isDeleting
    ? t("Stäng och radera prislistan")
    : t("Stäng utan att spara");

  const description = isDeleting
    ? t(
        "Vill du stänga prislistan utan att spara dina ändringar? Den osparade prislistan kommer att raderas permanent.",
      )
    : t("Vill du stänga prislistan utan att spara dina ändringar?");

  const confirmButtonText = isDeleting
    ? t("Stäng och radera")
    : t("Stäng utan att spara");

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      PaperProps={{
        sx: {
          borderRadius: 8,
        },
      }}
      onClose={onClose}
    >
      <DialogTitle sx={{ pt: 4, pb: 2 }}>
        <Typography fontSize={24}>{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack gap={1}>
          <Typography color="text.secondary" variant="body2">
            {description}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose}>{t("Avbryt")}</Button>
        <Button
          color={isDeleting ? "error" : "warning"}
          variant="text"
          onClick={onConfirm}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloseConfirmationDialog;
